import { Component, h } from 'preact'
import axios from 'axios'
import { User } from './interfaces'
import {
  LeaderboardEmptyMessage,
  LeaderboardSkeleton,
  LeaderboardUserListTable
} from './components'

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 50

interface Props {
  key: string
  tabTitle: string
  period: string
  isGuest: boolean
  loggedInUserId: string|null
}

interface State {
  usersList: User[]
  totalPages: number
  currentPage: number
  currentUser?: User
  period: string
  isLoading: boolean
  loggedInUserId: string|null
}

class LeaderboardOverview extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      usersList: [],
      totalPages: 0,
      currentPage: DEFAULT_PAGE,
      currentUser: undefined,
      period: props.period,
      isLoading: false,
      loggedInUserId: props.loggedInUserId
    }
    this.fetchLeaderboard = this.fetchLeaderboard.bind(this)
    this.fetchLoggedInLeaderboardUser = this.fetchLoggedInLeaderboardUser.bind(this)
    this.fetchData = this.fetchData.bind(this)
    this.generateNextUrl = this.generateNextUrl.bind(this)
  }

  async componentDidMount () {
    const params = new URLSearchParams(window.location.search)
    const page = params.get('page') ?? '1'
    await this.fetchData(this.props.period, parseInt(page))
  }

  async fetchData (period: string, page: number = DEFAULT_PAGE) {
    if (period !== this.state.period) {
      window.history.pushState(null, '', 'leaderboard')
    }
    this.setState({ period: period, isLoading: true })
    const fetchLoggedInUserSection = !this.props.isGuest && page === 1
    const [leaderboard, currentUser] = await Promise.all([this.fetchLeaderboard(page), fetchLoggedInUserSection ? this.fetchLoggedInLeaderboardUser() : undefined])
    const { result, totalPages, currentPage } = leaderboard
    this.setState({
      usersList: result,
      totalPages: totalPages,
      currentPage: currentPage,
      currentUser: currentUser,
      isLoading: false
    })
  }

  async fetchLeaderboard (page: number = DEFAULT_PAGE) {
    try {
      const res = await axios.get('/leaderboard/fetch', {
        params: {
          period: this.state.period,
          page: page,
          pageSize: DEFAULT_PAGE_SIZE
        }
      })

      if (res.data) {
        return res.data
      }
    } catch {
      return []
    }
  }

  async fetchLoggedInLeaderboardUser () {
    try {
      const res = await axios.get('/leaderboard/fetchUser', {
        params: {
          period: this.state.period
        }
      })
      if (Object.keys(res.data).length !== 0) {
        return res.data
      }
    } catch {
      return undefined
    }
  }

  generateNextUrl (newPage: number) {
    const { period } = this.state
    const baseUrl = '/leaderboard'
    const newPagination = newPage === 1 ? `?period=${period}` : `?period=${period}&page=${newPage}`
    return `${window.location.origin}${baseUrl}${newPagination}`
  }

  render ({ isGuest }: Props, { usersList, totalPages, currentPage, currentUser, isLoading, loggedInUserId }: State) {
    const isLeaderboardEmpty = usersList.length === 0
    const showCurrentlyLoggedInUserSection = !isGuest && currentPage === 1
    return (
      <div className='leaderboard-page'>
        {!isLoading && isLeaderboardEmpty && <LeaderboardEmptyMessage />}
        {isLoading || isLeaderboardEmpty ? <LeaderboardSkeleton isLoading={isLoading} /> : null}
        {!isLoading && !isLeaderboardEmpty && <LeaderboardUserListTable
          usersList={usersList}
          showCurrentlyLoggedInUserSection={showCurrentlyLoggedInUserSection}
          currentUser={currentUser}
          loggedInUserId={Number(loggedInUserId)}
          totalPages={totalPages}
          currentPage={currentPage}
          generateNewUrl={this.generateNextUrl}
                                              />}
      </div>
    )
  }
}
export default LeaderboardOverview
